import { IconArrowLeft } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import InputWithHiddenIcon from "./InputWithHiddenIcon";
import { useUpdateAppConfig } from "hooks";
import { useState } from "react";
import { isEqual } from "lodash";

const AppConfig = ({ appName, defaultConfig, onBack }) => {
  const { t: getLabel } = useTranslation();
  const { updateAppConfigAsync } = useUpdateAppConfig();

  const [config, setConfig] = useState(defaultConfig);
  const [isCallingApi, setIsCallingApi] = useState(false);

  const handleResetConfig = () => setConfig(defaultConfig);

  const handleSubmit = async () => {
    setIsCallingApi(true);
    await updateAppConfigAsync(config);
    setIsCallingApi(false);
  };

  const handleChangeContent = e => {
    const fieldName = e.target.name;
    const value = e.target.value;

    setConfig(prev => ({ ...prev, [fieldName]: value }));
  };

  const handleChangeHidden = e => {
    const fieldName = e.currentTarget?.name;
    const currentValue = config[fieldName];

    setConfig(prev => ({ ...prev, [fieldName]: Boolean(currentValue) ? 0 : 1 }));
  };

  const isDisableAction =
    false === Boolean((config.title || "").trim().length > 0 && !isEqual(defaultConfig, config)) || isCallingApi;

  return (
    <div className="card" style={{ width: "100%", height: "calc(100% - 75px)", padding: "32px 16px" }}>
      <div className="card-body">
        <div className="d-flex align-items-start justify-content-between mb-2">
          <div className="d-flex align-items-start gap-2">
            <button className="btn btn-icon btn-ghost-secondary" onClick={onBack}>
              <IconArrowLeft size={20} />
            </button>
            <div>
              <strong style={{ fontSize: 20 }}>{`${getLabel("TXT_CONFIG_APP")} ${appName}`}</strong>
              <p style={{ fontStyle: "italic", fontSize: 12, margin: 0 }}>
                {getLabel(LangConstant.TXT_APP_CONFIG_DESC, { appName })}
              </p>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-primary" disabled={isDisableAction} onClick={handleResetConfig}>
              {getLabel("L_CANCEL")}
            </button>
            <button className="btn btn-primary" disabled={isDisableAction} onClick={handleSubmit}>
              {getLabel("TXT_SAVE_CONFIG")}
            </button>
          </div>
        </div>

        <div style={{ padding: 16 }}>
          <strong style={{ fontSize: 16 }}>{getLabel(LangConstant.TXT_APP_TITLE_SECTION)}</strong>

          <div className="d-flex flex-column gap-3 mt-3">
            <InputWithHiddenIcon
              label={getLabel(LangConstant.TXT_TITLE_REQUIRED)}
              isHidden={Boolean(config.title_hidden_f)}
              TextFieldProps={{
                name: "title",
                value: config.title,
                maxLength: 50,
                required: true,
                onChange: handleChangeContent,
              }}
              IconButtonProps={{ name: "title_hidden_f", disabled: true, onClick: handleChangeHidden }}
            />
            <InputWithHiddenIcon
              label={getLabel(LangConstant.TXT_SUBTITLE)}
              isHidden={Boolean(config.subtitle_hidden_f)}
              TextFieldProps={{
                name: "subtitle",
                value: config.subtitle,
                maxLength: 50,
                onChange: handleChangeContent,
              }}
              IconButtonProps={{ name: "subtitle_hidden_f", onClick: handleChangeHidden }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppConfig;
